export const SPINNER_LOADING_TEMPLATE = 'Web.TemplatesInterface.v1_0.Touch.SpinnerLoadingTemplateInterface.SpinnerLoadingTemplate';
